<template>
  <div class="my-layout-box p-user">
    <section class="c-bankgroud p-user-message">
      <img :src="avatarURL" alt="头像" />
      <ul>
        <li>
          <span>{{ items.RealName }}</span>
        </li>
        <li>
          <span>手机号: </span>
          <i> {{ items.Mobile }}</i>
        </li>
      </ul>
    </section>
    <section class="c-bankgroud p-user-box">
      <router-link to="/user/myMessage">
        <ul class="c-user-ul">
          <li>
            <i class="c-ff6900 iconfont icon-gongsixinxi"> </i>
            <span>公司信息</span>
          </li>
          <li>
            <van-icon name="arrow" />
          </li>
        </ul>
      </router-link>

      <router-link to="/user/contract">
        <ul class="c-user-border-none c-user-ul">
          <li>
            <i class="c-ff6900 iconfont icon-yonghuxieyi"></i>
            <span>我的协议</span>
          </li>
          <li>
            <van-icon name="arrow" />
          </li>
        </ul>
      </router-link>
    </section>

    <section class="c-bankgroud p-user-box">
      <router-link to="/supplier">
        <ul class="c-user-ul">
          <li>
            <i class="c-00bbab iconfont icon-gongyingshang"></i>
            <span>供应商管理</span>
          </li>
          <li>
            <van-icon name="arrow" />
          </li>
        </ul>
      </router-link>
      <router-link to="/supplier/account">
        <ul class="c-user-ul">
          <li>
            <i class="c-00bbab iconfont icon-Supplieraccountm"></i>
            <span>供应商账户</span>
          </li>
          <li>
            <van-icon name="arrow" />
          </li>
        </ul>
      </router-link>
      <router-link to="/supplier/address">
        <ul class="c-user-border-none c-user-ul">
          <li>
            <i class="c-00bbab iconfont icon-dizhi"></i>
            <span>供应商提货地址</span>
          </li>
          <li>
            <van-icon name="arrow" />
          </li>
        </ul>
      </router-link>
    </section>

    <section class="c-bankgroud p-user-box">
      <router-link to="/user/salesman">
        <ul class="c-user-ul">
          <li>
            <i class="c-247be3 iconfont icon-iconfontzhizuobiaozhun0250"></i>
            <span>业务员</span>
          </li>
          <li>
            <van-icon name="arrow" />
          </li>
        </ul>
      </router-link>

      <router-link to="/user/receiverAddress">
        <ul class="c-user-border-none  c-user-ul">
          <li>
            <i class="c-247be3 iconfont icon-shouhuodizhi"></i>
            <span>收货地址</span>
          </li>
          <li>
            <van-icon name="arrow" />
          </li>
        </ul>
      </router-link>
    </section>

    <section class="c-bankgroud p-user-box">
      <router-link to="/user/coupon">
        <ul class="c-user-ul">
          <li>
            <i class="c-44b600  iconfont icon-zhangdan"></i>
            <span>我的优惠券</span>
          </li>
          <li>
            <van-icon name="arrow" />
          </li>
        </ul>
      </router-link>
      <router-link to="/user/message">
        <ul class=" c-user-ul">
          <li>
            <i class="c-44b600  iconfont icon-xiaoxiliebiao"></i>
            <span>消息列表</span>
          </li>
          <li>
            <van-icon name="arrow" />
          </li>
        </ul>
      </router-link>
      <router-link to="/user/customMessage">
        <ul class="c-user-border-none c-user-ul">
          <li>
            <i class="c-44b600  iconfont icon-dingzhi"></i>
            <span>信息定制</span>
          </li>
          <li>
            <van-icon name="arrow" />
          </li>
        </ul>
      </router-link>
    </section>

    <section class="c-bankgroud p-user-box p-user-out">
      <ul class="c-user-border-none c-user-ul" @click="onLogOut">
        <li style="text-align: center">
          <span>退出登录</span>
        </li>
      </ul>
    </section>
  </div>
</template>
<script>
import { getUser } from "~/api/userCenter";
import { Dialog } from "vant";
export default {
  name: "user",
  data() {
    return {
      items: {
        RealName: "",
        Mobile: ""
      },
      avatarURL: "/images/no-logo.webp"
    };
  },
  methods: {
    async getData() {
      const data = await getUser();
      if (data) {
        Object.keys(this.items).forEach(key => {
          this.items[key] = data[key];
        });
        if (data.Avatar) {
          this.avatarURL = `/avatar/${data.Id}/${data.Avatar}`;
        }
      }
    },
    onLogOut() {
      Dialog.confirm({
        message: "确定退出登录吗?"
      })
        .then(() => {
          this.onSignOut()
        })
        .catch(() => {
          // on cancel
        });
    },
    async onSignOut() {
      await this.$store.dispatch("user/signOut");
    }
  },
  created() {
    this.getData();
  }
};
</script>
<style lang="less">
.p-user {
  .c-bankgroud {
    background: #fff;
  }

  .p-user-message {
    display: flex;
    padding: 10px;
    font-size: 0.14rem;

    // background: #ffad00;
    img {
      width: 0.6rem;
      height: 0.6rem;
      border-radius: 50%;
      border: 1px solid #ccc;
    }

    ul {
      flex: 1;
      vertical-align: middle;
      padding: 10px;
      font-size: 0.14rem;

      li {
        margin-bottom: 5px;
      }

      i {
        font-style: normal;
      }
    }
  }

  .p-user-box {
    margin-top: 0.1rem;
    padding: 0 20px;
  }

  .c-user-ul {
    display: flex;
    justify-content: space-between;
    padding: 10px 0;
    border-bottom: 1px solid #dad8d8;
    color: #323233;
    font-size: 0.13rem;

    li {
      span {
        display: inline-block;
        margin-left: 10px;
      }
    }
  }

  .c-user-border-none {
    border: none;
  }

  .p-user-out {
    li {
      width: 100%;
      text-align: center;

      span {
        font-size: 0.15rem;
      }
    }
  }
}</style>
